import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
/// React router dom
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

/// Dashboard
import Home from "./components/Dashboard/Home";
import Products from "./components/Dashboard/Products";
import Projects from "./components/Dashboard/Projects";
import Task from "./components/Dashboard/Task";

//Apps
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import AppProfile2 from "./components/AppsMenu/AppProfile/AppProfile2";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAccordion from "./components/bootstrap/Accordion";
import UiAlert from "./components/bootstrap/Alert";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
// Widget
import Widget from "./pages/Widget";
/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";
/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
/// Pages
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import Candidate from "./components/Candidate/Candidate";
import SearchCandidate from "./components/Candidate/SearchCandidate";
import AddCandidateMaster from "./components/Candidate/AddCandidateMaster";
import Company from "./components/Company/Company";
import AddCompanyMaster from "./components/Company/AddCompanyMaster";
import SearchCompany from "./components/Company/SearchCompany";
import RequirementPlans from "./components/RequirementPlan/RequirementPlans";
import LOV from "./components/LOV/Lov";
import Templates from "./components/Templates/Templates";
import UpdateRequirementPlan from "./components/RequirementPlan/UpdateRequirementPlan";
import Reports from "./components/Reports/Reports";
import { isLogin } from "../services/AuthService";
import Login from "./pages/Login";

const allroutes = [
  // Dashboard
  { url: "", component: <Home /> },
  { url: "dashboard", component: <Home /> },
  { url: "products", component: <Products /> },
  { url: "project", component: <Projects /> },
  { url: "task", component: <Task /> },
  { url: "reports", component: <Reports /> },

  //Candidates
  { url: "candidates", component: <Candidate /> },
  { url: "add-candidate", component: <AddCandidateMaster /> },
  { url: "search-candidate", component: <SearchCandidate /> },

  //Compnies
  { url: "companies", component: <Company /> },
  { url: "search-company", component: <SearchCompany /> },
  { url: "add-company", component: <AddCompanyMaster /> },

  //Compnies
  { url: "requirement-plans", component: <RequirementPlans /> },
  { url: "lov", component: <LOV /> },
  { url: "templates", component: <Templates /> },
  { url: "update-requirement-plans", component: <UpdateRequirementPlan /> },

  // { url: "app-profile", component: <AppProfile /> },
  // { url: "app-profile-2", component: <AppProfile2 /> },
  // { url: "edit-profile", component: <EditProfile /> },
  // { url: "post-details", component: <PostDetails /> },

  // { url: "email-compose", component: <Compose /> },
  // { url: "email-inbox", component: <Inbox /> },
  // { url: "email-read", component: <Read /> },
  // { url: "app-calender", component: <Calendar /> },

  // { url: "ecom-product-grid", component: <ProductGrid /> },
  // { url: "ecom-product-list", component: <ProductList /> },
  // { url: "ecom-product-detail", component: <ProductDetail /> },
  // { url: "ecom-product-order", component: <ProductOrder /> },
  // { url: "ecom-checkout", component: <Checkout /> },
  // { url: "ecom-invoice", component: <Invoice /> },
  // { url: "ecom-customers", component: <Customers /> },

  // { url: "chart-sparkline", component: <SparklineChart /> },
  // { url: "chart-chartjs", component: <ChartJs /> },
  // { url: "chart-apexchart", component: <ApexChart /> },
  // { url: "chart-rechart", component: <RechartJs /> },

  // { url: "ui-accordion", component: <UiAccordion /> },
  // { url: "ui-alert", component: <UiAlert /> },
  // { url: "ui-badge", component: <UiBadge /> },
  // { url: "ui-button", component: <UiButton /> },
  // { url: "ui-modal", component: <UiModal /> },
  // { url: "ui-button-group", component: <UiButtonGroup /> },
  // { url: "ui-list-group", component: <UiListGroup /> },
  // { url: "ui-card", component: <UiCards />},
  // { url: "ui-carousel", component: <UiCarousel /> },
  // { url: "ui-dropdown", component: <UiDropDown /> },
  // { url: "ui-popover", component: <UiPopOver /> },
  // { url: "ui-progressbar", component: <UiProgressBar /> },
  // { url: "ui-tab", component: <UiTab /> },
  // { url: "ui-pagination", component: <UiPagination /> },
  // { url: "ui-typography", component: <UiTypography /> },
  // { url: "ui-grid", component: <UiGrid /> },

  // { url: "uc-select2", component: <Select2 /> },
  // { url: "uc-sweetalert", component: <MainSweetAlert /> },
  // { url: "uc-toastr", component: <Toastr /> },
  // { url: "uc-lightgallery", component: <Lightgallery /> },

  // { url: "widget-basic", component: <Widget /> },

  // { url: "form-element", component: <Element /> },
  // { url: "form-wizard", component: <Wizard /> },
  // { url: "form-ckeditor", component: <CkEditor /> },
  // { url: "form-pickers", component: <Pickers /> },
  // { url: "form-validation", component: <FormValidation /> },

  { url: "table-filtering", component: <FilteringTable /> },
  { url: "table-sorting", component: <SortingTable /> },
  { url: "table-bootstrap-basic", component: <BootstrapTable /> },
];

function NotFound() {
  const url = allroutes.map((route) => route.url);
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  if (url.indexOf(path) <= 0) {
    return <Error404 />;
  }
}

const Markup = () => {
  return (
    <>
      <Routes>
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route
          path="/"
          element={
            isLogin() ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/login"
          element={isLogin() ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route key={i} path={data.url} element={data.component} />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);

  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  // const handleToogle = () => {
  //   dispatch(navtoggle());
  // };
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${
        sideMenu ? "menu-toggle" : ""
      }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
